import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	backItem: {
		id: 'spa-apps-sidebar-software-classic.menu.settings.back-item',
		defaultMessage: 'Back',
		description: 'Back to project menu item.',
	},
	automation: {
		id: 'spa-apps-sidebar-software-classic.menu.settings.automation',
		defaultMessage: 'Automation',
		description: 'Settings navigation menu link for a software project',
	},
	features: {
		id: 'spa-apps-sidebar-software-classic.menu.settings.features',
		defaultMessage: 'Features',
		description: 'Settings navigation menu link for a software project',
	},
	details: {
		id: 'spa-apps-sidebar-software-classic.menu.settings.details',
		defaultMessage: 'Details',
		description: 'Settings navigation menu link for a software project',
	},
	people: {
		id: 'spa-apps-sidebar-software-classic.menu.settings.people',
		defaultMessage: 'People',
		description: 'Settings navigation menu link for a software project',
	},
	summary: {
		id: 'spa-apps-sidebar-software-classic.menu.settings.summary',
		defaultMessage: 'Summary',
		description: 'Settings navigation menu link for a software project',
	},
	deleteProject: {
		id: 'spa-apps-sidebar-software-classic.menu.settings.delete-project',
		defaultMessage: 'Delete project',
		description: 'Settings navigation menu link for a software project',
	},
	issueTypes: {
		id: 'spa-apps-sidebar-software-classic.menu.settings.issue-types',
		defaultMessage: 'Issue types',
		description: 'Settings navigation menu link for a software project',
	},
	issueLayout: {
		id: 'spa-apps-sidebar-software-classic.menu.settings.issue-layout',
		defaultMessage: 'Issue layout',
		description: 'Settings navigation menu link for a software project',
	},
	workflows: {
		id: 'spa-apps-sidebar-software-classic.menu.settings.workflows',
		defaultMessage: 'Workflows',
		description: 'Settings navigation menu link for a software project',
	},
	screens: {
		id: 'spa-apps-sidebar-software-classic.menu.settings.screens',
		defaultMessage: 'Screens',
		description: 'Settings navigation menu link for a software project',
	},
	fields: {
		id: 'spa-apps-sidebar-software-classic.menu.settings.fields',
		defaultMessage: 'Fields',
		description: 'Settings navigation menu link for a software project',
	},
	versions: {
		id: 'spa-apps-sidebar-software-classic.menu.settings.versions',
		defaultMessage: 'Releases',
		description: 'Settings navigation menu link for a software project',
	},
	components: {
		id: 'spa-apps-sidebar-software-classic.menu.settings.components',
		defaultMessage: 'Components',
		description: 'Settings navigation menu link for a software project',
	},
	opsgenie: {
		id: 'spa-apps-sidebar-software-classic.menu.settings.opsgenie',
		defaultMessage: 'Opsgenie',
		description: 'Settings navigation menu link to the Opsgenie integration config',
	},
	permissions: {
		id: 'spa-apps-sidebar-software-classic.menu.settings.permissions',
		defaultMessage: 'Permissions',
		description: 'Settings navigation menu link for a software project',
	},
	issueSecurity: {
		id: 'spa-apps-sidebar-software-classic.menu.settings.issue-security',
		defaultMessage: 'Issue security',
		description: 'Settings navigation menu link for a software project',
	},
	notifications: {
		id: 'spa-apps-sidebar-software-classic.menu.settings.notifications',
		defaultMessage: 'Notifications',
		description: 'Settings navigation menu link for a software project',
	},
	notificationsEmail: {
		id: 'spa-apps-sidebar-software-classic.menu.settings.notifications-email',
		defaultMessage: 'Notification email',
		description: 'Settings navigation menu link for a software project',
	},
	hipChat: {
		id: 'spa-apps-sidebar-software-classic.menu.settings.hip-chat',
		defaultMessage: 'HipChat integration',
		description: 'Settings navigation menu link for a software project',
	},
	devtools: {
		id: 'spa-apps-sidebar-software-classic.menu.settings.devtools',
		defaultMessage: 'Development tools',
		description: 'Settings navigation menu link to the development tools page',
	},
	issueCollectors: {
		id: 'spa-apps-sidebar-software-classic.menu.settings.issue-collectors',
		defaultMessage: 'Issue collectors',
		description: 'Settings navigation menu link for a software project',
	},
	settings: {
		id: 'spa-apps-sidebar-software-classic.menu.settings.settings',
		defaultMessage: 'Project settings',
		description: 'Navigation item which links to a project settings page',
	},
	forms: {
		id: 'spa-apps-sidebar-software-classic.menu.settings.forms',
		defaultMessage: 'Forms',
		description: 'Nav item label for configuring ProForma forms for a software project',
	},
	advancedForms: {
		id: 'spa-apps-sidebar-software-classic.menu.settings.advanced-forms',
		defaultMessage: 'Advanced Forms',
		description: 'Nav item label for configuring ProForma forms for a software project',
	},
	connections: {
		id: 'spa-apps-sidebar-software-classic.menu.settings.connections',
		defaultMessage: 'Connections',
		description: 'Nav item label managing DevOps connections in a software project',
	},
	types: {
		id: 'spa-apps-sidebar-software-classic.menu.settings.types',
		defaultMessage: 'Types',
		description: 'Settings navigation menu link for a software project',
	},
	layout: {
		id: 'spa-apps-sidebar-software-classic.menu.settings.layout',
		defaultMessage: 'Layout',
		description: 'Settings navigation menu link for a software project',
	},
	security: {
		id: 'spa-apps-sidebar-software-classic.menu.settings.security',
		defaultMessage: 'Security',
		description: 'Settings navigation menu link for a software project',
	},
	collectors: {
		id: 'spa-apps-sidebar-software-classic.menu.settings.collectors',
		defaultMessage: 'Collectors',
		description: 'Settings navigation menu link for a software project',
	},
	apps: {
		id: 'spa-apps-sidebar-software-classic.menu.settings.apps',
		defaultMessage: 'Apps',
		description: 'Settings navigation expandable menu for a software project',
	},
	issues: {
		id: 'spa-apps-sidebar-software-classic.menu.settings.issues',
		defaultMessage: 'Issues',
		description: 'Settings navigation expandable menu for a software project',
	},
	new: {
		id: 'spa-apps-sidebar-software-classic.menu.settings.new',
		defaultMessage: 'New',
		description: 'New lozenge shows on navigation. Indicate that the feature is new.',
	},
	dataClassificationNonFinal: {
		id: 'spa-apps-sidebar-software-classic.menu.settings.data-classification-non-final',
		defaultMessage: 'Data classification',
		description: 'Data classification link item within data protection sub-menu',
	},
	issueTypesIssueTermRefresh: {
		id: 'spa-apps-sidebar-software-classic.menu.settings.issue-types-issue-term-refresh',
		defaultMessage: 'Work types',
		description: 'Settings navigation menu link for a software project',
	},
	issueLayoutIssueTermRefresh: {
		id: 'spa-apps-sidebar-software-classic.menu.settings.issue-layout-issue-term-refresh',
		defaultMessage: 'Work item layout',
		description: 'Settings navigation menu link for a software project',
	},
	issueSecurityIssueTermRefresh: {
		id: 'spa-apps-sidebar-software-classic.menu.settings.issue-security-issue-term-refresh',
		defaultMessage: 'Work item security',
		description: 'Settings navigation menu link for a software project',
	},
	issueCollectorsIssueTermRefresh: {
		id: 'spa-apps-sidebar-software-classic.menu.settings.issue-collectors-issue-term-refresh',
		defaultMessage: 'Work item collectors',
		description: 'Settings navigation menu link for a software project',
	},
	issuesIssueTermRefresh: {
		id: 'spa-apps-sidebar-software-classic.menu.settings.issues-issue-term-refresh',
		defaultMessage: 'All work',
		description: 'Settings navigation expandable menu for a software project',
	},
});
